module.exports = __webpack_public_path__ + "static/media/watch-fitness.c58d58b2.svg";